export default "/images/vendor/@coreui/icons/svg/flag/cif-bb.svg?7a9c857148885a4381e9f0d3d3765431";